import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    return (
        <div>
            <div className="footer-copyright text-center py-3">
                <Container fluid>
                    &copy; {new Date().getFullYear()} Copyright: <a href="https://github.com/md-mohin-uddin"> Mohin </a>
                </Container>
            </div>
        </div>
    );
};

export default Footer;